import getDeviceLanguage from "./device-language";
import {Language, User, Municipal, Character, CharacterType, AppType} from "./types";

interface StorageData {
    user: User
    current_screen: string
    completed_screens: string[]
    app_type: AppType;
}

export class CattownStorage{
    //Cattown local storage
    private _storageItem = 'storage_cattown_data';

    constructor (){
        if(!this.checkIntegrity()) { this.setDefaultStorage(); }
    }

    private checkIntegrity(){
        const storageData = localStorage.getItem(this._storageItem);
        if(!storageData) return false;

        let storageDataJSON: any;
        try{
            storageDataJSON = JSON.parse(storageData);

        }catch(error){
            return false;
        } 

        if(
            !('user' in storageDataJSON ) 
            || !('current_screen' in storageDataJSON)
            || !('completed_screens' in storageDataJSON)
        ) return false;

        if(
            !('language' in storageDataJSON.user)
            || !('municipal' in storageDataJSON.user)
            || !('character' in storageDataJSON.user)
            || !('interact_with_cat_type' in storageDataJSON.user)
        ) return false;

        return true;
    }

    private setDefaultStorage(){
        const data: StorageData = {
            user: {
                language: getDeviceLanguage().short,
                municipal: '' as Municipal,
                character: {
                    accessories: {
                        glasses_color: '#1d1d1f',
                        tie_color: '#c62319',
                        necklace: false,
                    },
                    
                    dress_color: {
                        geek: '#efefef',
                        music: '#661212',
                        sport: '#222c4c',
                        fashion: '#ffecaf'
                    },
                    guitar_color:  '#000000',
                    type: 'geek'
                },
                interact_with_cat_type: '' as 'geek'
            },
            current_screen: '',
            completed_screens: [],
            app_type: 'web'
        }

        localStorage.setItem(this._storageItem, JSON.stringify(data))
    }
    
    getData(): StorageData {
        return JSON.parse(localStorage.getItem(this._storageItem)!) as StorageData;
    }

    getDataUser(): User{
        return this.getData().user;
    }

    //Set user language
    setLanguage(language: Language){
        const storageData = this.getData();
        storageData.user.language = language;
        this.save(storageData);

    }

    //Set user municipa
    setMunicipal(municipal: Municipal){
        const storageData = this.getData();
        storageData.user.municipal = municipal;
        this.save(storageData);
    }

    //set user character
    setCharacter(character: Character){
        const storageData = this.getData();
        storageData.user.character = character;
        this.save(storageData);
    }

    //set use character type
    setCharacterType(type: CharacterType){
        const storageData = this.getData();
        storageData.user.character.type = type;
        this.save(storageData);
    }

    //
    setInteractWithCatType(type: CharacterType){
        const storageData = this.getData();
        storageData.user.interact_with_cat_type = type;
        this.save(storageData);
    }

    //set active screen
    setCurrentScreen(screen: string){
        const storageData = this.getData();
        storageData.current_screen = screen;
        this.save(storageData);
    }

    //set screens completed by user
    setScreensCompleted(screens: string[]){
        const storageData = this.getData();
        storageData.completed_screens = screens;
        this.save(storageData);
    }

    setAppType(app_type: AppType){
        const storageData = this.getData();
        (storageData as any).app_type = app_type;
        this.save(storageData);
    }

    private save(data: StorageData){
        localStorage.setItem(this._storageItem, JSON.stringify(data))
    }

    destroy(){
        localStorage.removeItem(this._storageItem);
        this.setDefaultStorage();
    }

}